import { render, staticRenderFns } from "./TaskStatus.vue?vue&type=template&id=7d2f42c3&"
import script from "./TaskStatus.vue?vue&type=script&lang=ts&"
export * from "./TaskStatus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports